/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_ZoomInputs */

const en_read_along_zoom = /** @type {(inputs: Read_Along_ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom`)
};

const es_read_along_zoom = /** @type {(inputs: Read_Along_ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom`)
};

/**
* | output |
* | --- |
* | "Zoom" |
*
* @param {Read_Along_ZoomInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_zoom = /** @type {((inputs?: Read_Along_ZoomInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_ZoomInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_zoom(inputs)
	return en_read_along_zoom(inputs)
});